import React from 'react';
import MedicFooter from '../footer/MedicFooter';
import styles from './MedicalLayout.module.css';

const MedicalLayout = ({ children }) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <img
          src="/img/medic.png"
          alt="Logo"
          className={styles.logo}
        />
      </div>
      
      <div className={styles.content}>
        {children}
      </div>
      
      <MedicFooter />
    </div>
  );
};

export default MedicalLayout;
